(() => {
  if (customElements.get('ec-artist-description')) return;
  customElements.define('ec-artist-description', class extends HTMLElement {
    connectedCallback() {
      const clean = () => {
        this.querySelectorAll('.artist-footer').forEach(footer => {
          const legacyLink = Array.from(footer.querySelectorAll('a[href]')).find(link =>
            /^view\s+artist\s+bio\b|^about\s+/i.test(link.textContent.trim()));
          if (legacyLink) footer.remove();
        });
      };
      clean();
      this.ecObserver = new MutationObserver(clean);
      this.ecObserver.observe(this, {childList:true, subtree:true});
    }
    disconnectedCallback() { this.ecObserver?.disconnect(); }
  });
})();
